import React from "react";
import { Row, Col, Form, Button } from "antd";
import { withFormik } from "formik";
import FormikPersist from "src/components/FormikPersist";
import {
    Field,
    RenderField,
    RenderSelect,
} from "src/components";
import { Select } from "antd";
const Option = Select.Option;

const UserForm = (props) => {
    const { onFinishFailed, values, handleSubmit, isSubmitting } = props;
    // console.log("🚀 ~ file: index.tsx ~ line 8 ~ values", values);

    return (
        <Form onFinish={handleSubmit} onFinishFailed={onFinishFailed}>
            {typeof window !== "undefined" && !isSubmitting && (
                <FormikPersist name={window?.location?.pathname} />
            )}

            <Row gutter={24}>
                <Col lg={12} md={24}>
                    <Field
                        label="User Name"
                        placeholder="User Name"
                        name={"name"}
                        icon="FontSizeOutlined"
                        component={RenderField}
                        type="text"
                        value={values.name}
                        rules={[{ required: true }]}
                    />
                </Col>

                <Col lg={12} md={24}>
                    <Field
                        label="User role"
                        placeholder="User role"
                        name={"role"}
                        icon="FontSizeOutlined"
                        component={RenderSelect}
                        type="text"
                        value={values.role}
                        rules={[{ required: true }]}
                    >
                        <Option value="admin">Admin</Option>
                        <Option value="creator">Creator</Option>
                        <Option value="memer">Memer</Option>
                        <Option value="block_status">
                            Block Status Updater
                        </Option>
                        <Option value="anonymous">Anonymous</Option>
                        <Option value="audio_editor">Audio/Video Editor</Option>
                        <Option value="viewer">Viewer</Option>
                    </Field>
                </Col>

                <Col lg={12} md={24}>
                    <Field
                        label="User email"
                        placeholder="User email"
                        name={"email"}
                        icon="FontSizeOutlined"
                        component={RenderField}
                        type="email"
                        value={values.email}
                        rules={[{ required: true }]}
                    />
                </Col>

                <Col lg={12} md={24}>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

const UserFormWithFormik = withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props: any) => {
        const { user } = props;
        return {
            ...(user?.id ? { id: user.id } : {}),
            name: user?.name || null,
            email: user?.email || null,
            role: user?.role || null,
        };
    },

    async handleSubmit(values, { props: { onFinish } }: any) {
        await onFinish(values);
    },
    ...(typeof window !== "undefined" && {
        displayName: window?.location?.pathname, // helps with React DevTools
    }),
});

export default UserFormWithFormik(UserForm);
